/**
 * @file 推荐 prompt 列表
 * @author malcolmmzma
 */

import React from 'react';
import { Skeleton, Text } from '@tencent/odc';

import './index.less';

export type RecommendPrompt = {
  id: string;
  title: string;
  description?: string;
  tag?: string;
  icon?: React.ReactNode;
};

const RecommendPromptList = (props: {
  data: Array<RecommendPrompt>;
  onClick?: (item: RecommendPrompt) => void;
  loading?: boolean;
}) => {
  const { data, onClick, loading } = props;

  return (
    <div className="recommend-prompt-list tw-grid tw-grid-cols-3 tw-gap-6">
      {data.map((item) => (
        <div key={item.id} onClick={() => onClick?.(item)} className="recommend-prompt-item">
          {!loading ? (
            <>
              {item.tag && (
                <span className="tw-absolute tw-top-0 tw-right-0 tw-bg-blue-05 tw-text-white-00 tw-text-[10px] tw-font-semibold tw-px-[3px] tw-py-0.5 tw-rounded-l-[5px] tw-rounded-br-[5px]">
                  {item.tag}
                </span>
              )}
              <div className='recommend-prompt-item__content'>
                <p className="tw-font-semibold">{item.title}</p>
                <Text type='secondary' size='small' style={{ lineHeight: '20px' }}>{item?.description}</Text>
                {item.icon && <div className="icon">{item.icon}</div>}
              </div>
            </>
          ) : (
            <Skeleton width={'100%'} height={64} radius={12} />
          )}
        </div>
      ))}
    </div>
  );
};

export default RecommendPromptList;
